<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReportLayout'
}
</script>
